import React from 'react';
import resources from '../../../services';
import DataTable from '../../../composents/DataTable';
import MainPage from '../../../composents/MainPage';

const title = 'Group Of Meters';
const headers = {
	icon: 'feather icon-droplet',
	title: title,
	description: 'track and manage all meter group information',
};

export default function GroupOfMeterPage() {
	return (
		<MainPage headers={headers} show_search>
			<DataTable
				column={[
					{ label: 'Group name', field: 'name' },
					{
						label: 'Zone name',
						field: 'zone',
						render: ['zone'],
					},
					{
						label: 'Zone location',
						field: 'zone',
						render: ['location'],
					},
					{
						label: 'total consumption',
						field: 'consumption',
					},
					{
						label: 'Client',
						field: 'client',
						render: ['name'],
					},
					{
						label: 'Note',
						field: 'description',
					},
				]}
				resource={resources.groupOfMeter}
				title={title}
				link="/meters/groups"
			/>
		</MainPage>
	);
}
